"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _type = require("../actions/question/type");
var feedbackQuestionsReducer = function feedbackQuestionsReducer(state, _ref) {
  var type = _ref.type,
    payload = _ref.payload;
  var currentFeedbackState = state;
  switch (type) {
    case _type.UPDATE_QUESTIONNAIRE:
      return payload;
    default:
      return currentFeedbackState;
  }
};
var _default = exports["default"] = feedbackQuestionsReducer;
//# sourceMappingURL=feedbackQuestions.js.map